import api from '../../axios_api'
import _ from 'lodash'
import Promise from 'bluebird'
import router from '../../main'

const state = {
    server_data: [],
    todo_data: [],
    index: {},
    current_component: 'dashboard',
    allTodos: [],
    completedTodos: [],
    quickTaskList: [],
    everythingList: [],
    todoUsers: [],
    context: '',
    showModal: false
}

const getters = {

    current_component: (state) => {
        return state.current_component;
    },
    // componentTodos: (state, mutations) => (component, workspace) => {
    //     let todoData = JSON.parse(JSON.stringify(state.todo_data));
    //     if (todoData.length <= 0) {
    //         let todoApi = api.get('/todo/' + workspace, {})
    //             .then(res => {
    //                 // merge returns with our data
    //                 //commit('merge', res.data.encrypt.data)
    //                 return Promise.resolve(res.data.encrypt.data)
    //             })
    //             .catch(err => {
    //                 console.error(`Error during fetch: ${err}`)
    //                 return Promise.reject(err)
    //             })
    //         todoApi.then(data => {
    //             //state.server_data = data;
    //             //state.todo_data = data;
    //             todoData = data;
    //             let port = [];
    //             let other = [];
    //             let completed = [];
    //             todoData.map((data) => {
    //                 if (data.component == component) {
    //                     if (data.status) {
    //                         if (data.status == 'Done') {
    //                             completed.push(data);
    //                         }
    //                         else {
    //                             port.push(data);
    //                         }
    //                     }
    //                     else {
    //                         port.push(data);
    //                     }
    //                 }
    //                 else {
    //                     if (data.status) {
    //                         if (data.status == 'Done') {
    //                             completed.push(data);
    //                         }
    //                         else {
    //                             other.push(data);
    //                         }
    //                     }
    //                     else {
    //                         other.push(data);
    //                     }
    //                 }
    //             })
    //             state.todo_data = JSON.parse(JSON.stringify(port.concat(other)));
    //             // mutations["todo"]["todo_data"] = JSON.parse(JSON.stringify(port.concat(other)));
    //             return state.todo_data;
    //         })
    //     }
    //     else {
    //         let port = [];
    //         let other = [];
    //         let completed = [];
    //         todoData.map((data) => {
    //             if (data.component == component) {
    //                 if (data.status) {
    //                     if (data.status == 'Done') {
    //                         completed.push(data);
    //                     }
    //                     else {
    //                         port.push(data);
    //                     }
    //                 }
    //                 else {
    //                     port.push(data);
    //                 }
    //             }
    //             else {
    //                 if (data.status) {
    //                     if (data.status == 'Done') {
    //                         completed.push(data);
    //                     }
    //                     else {
    //                         other.push(data);
    //                     }
    //                 }
    //                 else {
    //                     other.push(data);
    //                 }
    //             }
    //         })
    //         state.todo_data = JSON.parse(JSON.stringify(port.concat(other)));
    //         // mutations["todo"]["todo_data"] = JSON.parse(JSON.stringify(port.concat(other)));
    //         return state.todo_data;
    //     }
    // },
    componentTodos: (state, mutations) => (component, workspace) => {
        let todoData = JSON.parse(JSON.stringify(state.todo_data));
        //if (todoData.length <= 0) {
        let todoApi = api.get('/todo/' + workspace, {})
            .then(res => {
                // merge returns with our data
                //commit('merge', res.data.encrypt.data)
                return Promise.resolve(res.data.encrypt.data)
            })
            .catch(err => {
                console.error(`Error during fetch: ${err}`)
                return Promise.reject(err)
            })
        todoApi.then(data => {
            //state.server_data = data;
            //state.todo_data = data;
            todoData = data;
            let port = [];
            let other = [];
            let completed = [];
            todoData.map((data) => {
                if (data.component == component) {
                    if (data.status) {
                        if (data.status == 'Done') {
                            completed.push(data);
                        }
                        else {
                            port.push(data);
                        }
                    }
                    else {
                        port.push(data);
                    }
                }
                else {
                    if (data.status) {
                        if (data.status == 'Done') {
                            completed.push(data);
                        }
                        else {
                            other.push(data);
                        }
                    }
                    else {
                        other.push(data);
                    }
                }
            })
            state.todo_data = JSON.parse(JSON.stringify(port.concat(other)));
            return state.todo_data;
        })
        //}
    },

    todos: (state, getters, mutations) => {
        return state.todo_data
    },
    all_todos: (state) => {
        return state.allTodos;
    },
    completed_todos: (state) => {
        return state.completedTodos;
    },
    workspaceTodos: (state) => {
        // let workspaceTodos = state.allTodos.concat(state.completedTodos);
        let workspaceTodos = [];
        if (Array.isArray(state.allTodos) && Array.isArray(state.completedTodos)) {
            workspaceTodos = [...state.allTodos, ...state.completedTodos];
        }
        return workspaceTodos;
    },
    context: (state) => state.context,
    showModal: (state) => state.showModal,
}

const mutations = {
    initialize(state) {
        state.server_data = [],
            state.todo_data = [],
            state.index = {},
            state.context = '',
            state.showModal = false
    },
    setTodoData(state, payload) {

        state.todo_data.push(payload);
        state.todo_data.sort((a, b) => {
            return new Date(a.due_date) - new Date(b.due_date);
        })
    },
    setTodoIndex(state, payload) {

        state.index[payload._id] = payload.index;
    },
    EditTodoData(state, payload) {
        state.todo_data[state.index[payload._id]] = payload;
        state.todo_data.sort((a, b) => {
            return new Date(a.due_date) - new Date(b.due_date);
        })
    },
    merge(state, payload) {
        // merge our local with what has returned
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        state.server_data = _.map(state.server_data, addr => {
            let index = _.findIndex(payload, function (a) { return a._id === addr._id })
            if (index >= 0) {
                return _.first(_.pullAt(payload, index))
            }
            return addr
        })

        if (!_.isEmpty(payload)) state.server_data = _.concat(state.server_data, payload)
        state.server_data = _.without(state.server_data, null, undefined)

        state.todo_data = JSON.parse(JSON.stringify(state.server_data));
    },
    remove(state, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return
        // remove the item by the id (either _id or uaid)
        state.server_data = _.filter(state.server_data, function (a) { return a._id !== payload && a.uaid !== payload })
    },
    setCurrentComponent(state, component) {
        state.current_component = component
    },
    setAllAndCompletedTodos(state, payload) {
        state.allTodos = payload.allTodos;
        state.completedTodos = payload.completedTodos;
    },
    setAllTodos(state, payload) {
        state.allTodos = payload;
    },
    setCompletedTodos(state, payload) {
        state.completedTodos = payload;
    },
    setNotificationTodo(state, payload) {
        state.context = payload.context;
        state.showModal = payload.showModal;
    }
}
const actions = {
    start({ state, dispatch }) {

        dispatch('getTodos')
            .then(() => {
            })
            .catch(() => { })
    },
    stop({ state, commit }) {
        // clean up
        commit('initialize')
    },
    getTodos({ commit }, payload) {
        return api.get('/todo', {})
            .then(res => {
                // merge returns with our data
                commit('merge', res.data.encrypt.data)
                return Promise.resolve(res.data.encrypt.data)
            })
            .catch(err => {
                console.error(`Error during fetch: ${err}`)
                return Promise.reject(err)
            })
    },
    getAllTodos({ commit }, payload) {
        return api.get(`/allTodos/${payload}`, {})
            .then(response => {
                commit('setAllAndCompletedTodos', response.data.encrypt);
            })
            .catch(error => {
                console.log('error in getAllTodos', error)
            })
    },
    getCompleteTodos({ commit }, payload) {
        return api.get(`/completedTodos/${payload}`, {})
            .then(response => {
                commit('setCompletedTodos', response.data.encrypt.completedTodos);
                return Promise.resolve(response.data.encrypt)
            })
            .catch(error => {
                console.log('error in getCompleteTodos', error);
                return Promise.reject(err);
            })
    },
    getTotalTodos({ commit }, payload) {
        return api.get(`/totalTodos/${payload}`, {})
            .then(response => {
                commit('setAllTodos', response.data.encrypt.allTodos);
                return Promise.resolve(response.data.encrypt);
            })
            .catch(error => {
                console.log('getTotalTodos in getAllTodos', error);
                return Promise.reject(err)
            })
    },
    apipostTodo({ }, payload) {
        return api.post(`/todo`, { encrypt: { data: { "todo": payload } } })
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(error => {
                return Promise.reject(err)
            })
    },
    apiPostTaxTodo({ }, payload) {
        return api.post(`/tax/todo`, { encrypt: { data: payload } })
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(error => {
                return Promise.reject(err)
            })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}